var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flag)?_c('section',{staticClass:"common-QRcode",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"common-QRcode-market u-7-bg"}),_c('div',{staticClass:"common-QRcode-maxEvm h-2-bg"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }